// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__89FsP","errorLogs":"EditorFooter_errorLogs__3YxqO"};